export const POST_LOGOUT_RETURN_URL = "LogoutPath"
export const ACCESS_TOKEN = "CPH.SSO.Token"
export const IDP_USER_ID = "CPH.IdP.User"
export const IDP_TOKEN_LOGIN = "CPH.Token.Login"
export const GTM_AB_EVENT = "GTM.AB.EVENT"
export const CPH_TEMP_USER = "CPH.Temp.User.js"
export const CPH_FOLLOW_FLIGHT = "CPH.Follow.Flight.js"
export const CPH_TRAVEL_INFORMATION = "CPH.Travel.Information.js"
